import CommonIcon from '_c/common-icon'
import { showTitle } from '@/libs/util'
export default {
  components: {
    CommonIcon
  },
  methods: {
    showTitle (item) {
      return showTitle(item, this)
    },
    showChildren (item) {
      const children = item.children || [];
      return children.filter(i => i.hasPermission !== false).length > 1 || (item.meta && item.meta.showAlways)
    },
    availableChildren (item) {
      const children = item.children || [];
      return children.filter(i => i.hasPermission !== false);
    },
    getNameOrHref (item, children0) {
      return item.href ? `isTurnByHref_${item.href}` : (children0 ? item.children[0].name : item.name)
    }
  }
}
